<template>
    <div class="range-slider">
        <div class="w-50">
            <div class="mb-2">
                <vue-slider tooltip="none" :interval="1" :min="min" :max="max"  @change="onInput" :value="valueLocal" :enable-cross="false"/>
            </div>
            <div class="form-control d-flex justify-content-between" style="max-width: 150px">
                <b>{{start}}</b>-
                <b>{{end}}</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DurationRangeSlider',
  props: {
    value: Array,
    min: Number,
    max: Number
  },
  computed: {
    valueLocal () {
      return this.value === null ? [this.min, this.max] : this.value
    },
    start: function () {
      return this.valueLocal && this.valueLocal.length > 0 ? this.valueLocal[0] : 0
    },
    end: function () {
      return this.valueLocal && this.valueLocal.length > 0 ? this.valueLocal[1] : 0
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/DurationRangeSlider.vue